export const listNfcTags = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs("/nfc/list", JSON.stringify({}));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

// Create a new NFC tag and return the tagId
export const createNfcTag = async (sendAndWaitWs, nfcTag) => {
  const response = await sendAndWaitWs("/nfc/create", JSON.stringify(nfcTag));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

// Activate an NFC tag after successful write
export const activateNfcTag = async (sendAndWaitWs, tagId) => {
  const response = await sendAndWaitWs(
    "/nfc/activate",
    JSON.stringify({ tagId })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const deleteNfcTag = async (sendAndWaitWs, tagId) => {
  const response = await sendAndWaitWs(
    "/nfc/batchDelete",
    JSON.stringify({
      tagIds: [tagId],
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const batchDeleteNfcTags = async (sendAndWaitWs, tagIds) => {
  const response = await sendAndWaitWs(
    "/nfc/batchDelete",
    JSON.stringify({
      tagIds,
    })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

// List available trusted sources (phones) for NFC tags
export const listNfcSources = async (sendAndWaitWs) => {
  const response = await sendAndWaitWs("/nfc/sources", JSON.stringify({}));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

// Update NFC tag configuration including policy and trusted sources
export const updateNfcTag = async (sendAndWaitWs, nfcTag) => {
  const response = await sendAndWaitWs("/nfc/update", JSON.stringify(nfcTag));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
